import{default as models}from"./model";import{default as scopes}from"./scope";export default{models,scopes};